import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteGroupActions } from "store/ducks/settings/groups";

export function* deleteGroupRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/groups/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteGroupActions.success(data));
    notify("success", "Grupo deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteGroupActions.failure(errorMessage));
  }
}
